
SJ.ItemsManager = 
class {
  constructor() {
    this._items = []; 
    this._activeItems = [];
  }

  loadItemsFromDB(callback){
    fetch(`${SJ.APILink}item/getAll.php?userName=${SJ.playerData.data['name']}`)
    .then(res => {
      return res.json();
    })
    .then(res => {
      res.forEach(item => {
        this.addItem(new SJ.Item(item['id'], item['name'], item['imgName'], item['varName'], item['increment'], item['des'], 'unSet', item['priceP1'], item['priceP2'], item['effectP1'], item['effectP2'], item['orderNumber']));
      });

      let areItemsReady = false;
      while(!areItemsReady){

        this._items.forEach(item => {
          if(item.level !== 'unSet') areItemsReady = true;
          else areItemsReady = false;
        });

      }

      window.setTimeout(callback(), 1500); 
    })
    
  }

  createActiveItems() {
    // this.defaultItems.push(new SJ.Item("Narty", "skis.png", "padFriction", false, "Super narty zmniejszające tarcie"));

    // this.defaultItems.push(new SJ.Item("Buty", "boots.png", "jumperJumpForce", true, "Buty zwiększające siłę wybicia"));

    // this.defaultItems.push(new SJ.Item("Skrzydła", "wings.png", "liftForce", true, "Małe skrzydełka zwiększające siłę nośną"));

    // this.defaultItems.push(new SJ.Item("Opływowy kombinezon", "suit.png", "airFriction", false, "Kombinezon o bardziej opływowym kształcie\nzmniejszający opory powietrza"));

    // this.defaultItems.push(new SJ.Item("Stabilizator lotu", "stabiliser.png", "airRotateForce", false, "Wszczep pomagający utrzymać dobrą\npozycję przy silnym wietrze"));

    // this.defaultItems.push(new SJ.Item("Wspomagacz lądowania", "landingHelper.png", "goodLandingAngle", true, "Wszczep wspomagający lądowanie\npod złym kątem"));

    // this.defaultItems.push(new SJ.Item("Wiązania", "landingHelper.png", "jumperTurnForce", true, "Przyspieszenie sterowania skoczkiem"));

    const jetPackItem = new SJ.ActiveItem("JetPack", "jetPack.png", "Jet pack wspomagający lot", 200, () => {
      if(SJ.jumper.state == SJ.jumper.S.FLYING) {
        SJ.jumper.accelerateWithForce(SJ.V.jumperJumpForce);
        return true;
      }

      return false;
    });
    jetPackItem.afterActivate = () => {
      jetPackItem.isActive = false;
      jetPackItem.disabled = true;
    }

    this.addItem(jetPackItem);
      
  }

  _testItems() {
    const it = new SJ.Item("Foka", "padFriction", 0.5, "", 10);

    print("Begin\n")
    print("Pad friction ", SJ.V.padFriction);
    
    this.addItem(it)
    print("After add:\n", this._items);
    print("Pad friction ", SJ.V.padFriction);
    
    this.removeItem(it);
    print("After remove:\n", this._items);
    print("Pad friction ", SJ.V.padFriction);

    const ait = new SJ.ActiveItem("Foo", "HAHAH", 10, () => {});
    this.addItem(ait)
    print("After add ACTIVE:\n", this._activeItems);
    
    this.removeItem(ait);
    print("After remove ACTIVE:\n", this._activeItems);

    print("END")
  }

  addItem(item) {
    if(item.isActiveItem === true) {
      this._activeItems.push(item);
    }else {
      this._items.push(item); 
    }
  }

  removeItem(item) {
    if(item.isActiveItem === true) {
      var itemsList = this._activeItems;
    }else {
      item.unequip();
      var itemsList = this._items;      
    }

    for(let i=0; i<itemsList.length; i++) {
      if(itemsList[i] === item) {
        itemsList.splice(i, 1);
        return;
      }
    }
  }
  
  calculateImtesVariables() {
    this._items.forEach(item => {
      item.calculateVariables();
    })
  }

  equipAllItems() {
    console.log('%c Items values', 'color: orange');

    this._items.forEach(item => {
      item.equip();
    });

    SJ.itemsDisplay.resetItemButtons();

    console.log('%c all items equiped', 'color: orange');
  }

  unequipAllItems() {
    this._items.forEach(item => {
      item.unequip();
    });
  }

  deactivateAllItemsRunOfLuck(){
    this._items.forEach(item => {
      item.deactivateRunOfLuck();
    })
  }

  setDefaultVarValues(){
    this._items.forEach(item => {
      item.setDefaultVarValue();
    })
  }

  resetActiveItems() {
    this._activeItems.forEach(item => {
      item.reset();
    });
  }

  getItemsCount() {
    return this._items.length + this._activeItems.length;
  }

  onKeyPressed() {
    if(keyCode > 48 && keyCode < 58) {
      const itemIdx = keyCode - 49;
      if(itemIdx < this._activeItems.length) {
        const item = this._activeItems[itemIdx];
        if(item.disabled) {
          return;
        }
        // if(item.activate()) {
        //   item.afterActivate();
        // }
      }
    }
  }

}